import script from "./RejectProjectEstimateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RejectProjectEstimateModal.vue?vue&type=script&setup=true&lang=ts"

import "./RejectProjectEstimateModal.vue?vue&type=style&index=0&id=0020a351&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0020a351"]])

export default __exports__